import React from "react";

export const chevronRight = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 40 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.14001 0L0.898438 8.24203L22.6564 30L0.898438 51.758L9.14001 60L39.14 30L9.14001 0Z"
        fill="currentColor"
      />
    </svg>
  );
};
